import { currentTheme } from './themeConfig';

const hexToRgba = (hex: string, alpha: number): string => {
  let normalized = hex.trim().replace('#', '');
  if (normalized.length === 3) {
    normalized = normalized.split('').map((char) => char + char).join('');
  }
  const r = parseInt(normalized.slice(0, 2), 16);
  const g = parseInt(normalized.slice(2, 4), 16);
  const b = parseInt(normalized.slice(4, 6), 16);
  if (Number.isNaN(r) || Number.isNaN(g) || Number.isNaN(b)) {
    return hex;
  }
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

/**
 * Inject CSS custom properties derived from the active theme.
 * Call this once at app bootstrap (owned by shell wiring).
 */
export const injectThemeTokens = (): void => {
  if (typeof document === 'undefined') {
    return;
  }

  const root = document.documentElement;

  root.style.setProperty('--theme-color', currentTheme.color);
  root.style.setProperty('--theme-color-light', hexToRgba(currentTheme.color, 0.1));
  root.style.setProperty('--theme-color-hover', hexToRgba(currentTheme.color, 0.2));
  root.style.setProperty('--font-family', currentTheme.fontFamily);
  root.style.setProperty('--font-weight-light', String(currentTheme.fontWeights.light));
  root.style.setProperty('--font-weight-regular', String(currentTheme.fontWeights.regular));
  root.style.setProperty('--font-weight-bold', String(currentTheme.fontWeights.bold));
  root.style.setProperty('--card-header-bg', '#f7f9fb');
  root.style.setProperty('--card-header-border', 'var(--surface-border)');
  root.style.setProperty('--card-header-text', 'var(--surface-text)');
};

export { currentTheme };
